import React, { useEffect, useState } from "react"
import { CustomModal } from "../../components/Modal/CustomModal"
import { useAuth } from "../../context/AuthContext";
import { User } from "../../types/user";
import { formatCPFCNPJ } from "../../utils/formatCPFCNPJ";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { InputSenha } from "../../components/generics/input-reset";

export const Perfil = () => {
  const { cookies, decodedToken, error, resetPassword, setError } = useAuth();
  const [openModal, setOpenModal] = useState(false)

  const [user, setUser] = useState<User>({} as User)

  function decoded() {
    if (cookies?.token) {
      const userDecoded = decodedToken()
      setUser(userDecoded)
    }
  }
  useEffect(() => {
    decoded()
  }, [cookies?.token])


  const [senhaAtual, setSenhaAtual] = useState("")
  const [novaSenha, setNovaSenha] = useState("")
  const [confirmarSenha, setConfirmarSenha] = useState("")
  const [erroSenha, setErroSenha] = useState("")


  const [showSenhaAtual, setShowSenhaAtual] = useState(false)
  const [showNovaSenha, setShowNovaSenha] = useState(false)
  const [showConfirmarSenha, setShowConfirmarSenha] = useState(false)

  const validarSenha = (senha: string) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
    return regex.test(senha)
  }

  const handleChangePassword = async () => {
    setErroSenha("")
    setError("")
    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      setErroSenha("Preencha todos os campos")
      return
    }

    if (!validarSenha(novaSenha)) {
      setErroSenha(
        "A senha deve ter no mínimo 8 caracteres, com pelo menos 1 letra maiúscula, 1 minúscula e 1 número"
      )
      return
    }

    if (novaSenha !== confirmarSenha) {
      setErroSenha("As senhas não coincidem")
      return
    }

    try {
      const resetPass = {
        login: user.login, oldPassword: senhaAtual, newPass: novaSenha
      }
      await resetPassword(resetPass)
      handleClose()
      return
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    setOpenModal(false)
    setSenhaAtual("")
    setNovaSenha("")
    setConfirmarSenha("")
    setErroSenha("")
    setError("")
  }




  return (
    <section>
      <div className="bg-white shadow-md rounded-lg p-6 space-y-4 m-4 mt-12">
        <h1 className="text-2xl font-semibold">Perfil</h1>

        <div className="grid grid-cols-1 gap-2 text-gray-800">
          <p><span className="font-medium">Login:</span> {user?.login}</p>
          <p><span className="font-medium">Nome:</span> {user?.nome}</p>
          <p><span className="font-medium">CPF/CNPJ:</span> {formatCPFCNPJ(user?.cpf_cnpj || '')}</p>
          <p><span className="font-medium">Perfil:</span> {user?.perfil}</p>
          <p><span className="font-medium">Loja:</span> {user?.id_loja}</p>
        </div>

        <button
          onClick={() => setOpenModal(true)}
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          Alterar senha
        </button>
      </div>

      <CustomModal
        isOpen={openModal}
        onClose={handleClose}
        title="Alterar senha"
        width="w-[400px]"
      >
        <div className="flex flex-col gap-3">

          {erroSenha && (
            <p className="text-red-600 text-sm text-center w-full">{erroSenha}</p>
          )}

          {error && (
            <p className="text-red-600 text-sm text-center w-full">{error}</p>
          )}


          <InputSenha
            label="Senha atual"
            value={senhaAtual}
            onChange={(e) => setSenhaAtual(e.target.value)}
            show={showSenhaAtual}
            toggleShow={() => setShowSenhaAtual(!showSenhaAtual)}
          />

          <InputSenha
            label="Nova senha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            show={showNovaSenha}
            toggleShow={() => setShowNovaSenha(!showNovaSenha)}
          />

          <InputSenha
            label="Confirmar nova senha"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            show={showConfirmarSenha}
            toggleShow={() => setShowConfirmarSenha(!showConfirmarSenha)}
          />

          <div className="flex justify-end gap-2 mt-2">
            <button
              onClick={handleClose}
              className="px-4 py-2 rounded bg-gray-300"
            >
              Cancelar
            </button>

            <button
              onClick={handleChangePassword}
              className="px-4 py-2 rounded bg-green-600 text-white"
            >
              Salvar
            </button>
          </div>
        </div>
      </CustomModal>
    </section>
  )
}